




















import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import ContentFeedCover from "@/components/ContentFeedCover";
import NotificationItemView from "../../NotificationItemView.vue";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";

export default defineComponent({
  name: "NotificationLike",
  components: { ScreenNamePrinter, NotificationItemView, ContentFeedCover },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const contentSet = computed<ContentSet>(() => props.notification.details.content.contentSet);
    const type = computed(() => (contentSet.value.type === ContentFeedTypeEnum.STORY ? $t("story") : $t("post")));

    const { authUserStrict } = useAuthUser();
    const subjectUrl = computed<Location>(() => {
      return getProfileUrl(authUserStrict.value, { feedId: props.notification.subjectId });
    });

    return {
      contentSet,
      subjectUrl,
      type,
    };
  },
});
